import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle, Wheat } from "lucide-react";
import { api } from "@/lib/api";

export default function Footer() {
  const [cfg, setCfg] = useState({
    business_name: "Aaha Kanakam Agri Traders",
    business_email: "Aahakanakamagri.traders@gmail.com",
    business_phone: "+91 9502747531",
    business_whatsapp: "919848490057",
    business_whatsapp_secondary: "919502747531",
    business_address: "5-92 Veeramma Colony, Piduguralla, Guntur, Andhra Pradesh, India — 522413",
  });
  useEffect(() => {
    api.get("/site-config").then(({ data }) => setCfg((c) => ({ ...c, ...data }))).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="bg-forest text-white/85">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-11 h-11 rounded-full bg-gold text-forest flex items-center justify-center">
              <Wheat size={22} />
            </div>
            <div>
              <div className="font-serif text-xl">{cfg.business_name}</div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-gold">Agricultural Commodities · India</div>
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed max-w-sm">
            Sourcing and supplying selected agricultural commodities from India for buyers, distributors, processors and trading partners across domestic and international markets.
          </p>
        </div>

        <div className="lg:col-span-2">
          <div className="eyebrow text-gold mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-gold">About</Link></li>
            <li><Link to="/commodities" className="hover:text-gold">Commodities</Link></li>
            <li><Link to="/services" className="hover:text-gold">Services</Link></li>
            <li><Link to="/quality" className="hover:text-gold">Quality</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-2">
          <div className="eyebrow text-gold mb-4">Trade</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/markets" className="hover:text-gold">Markets</Link></li>
            <li><Link to="/logistics" className="hover:text-gold">Packaging & Logistics</Link></li>
            <li><Link to="/quotation" className="hover:text-gold">Request a Quote</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="eyebrow text-gold mb-4">Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-gold" /><a data-testid="footer-email" href={`mailto:${cfg.business_email}`} className="hover:text-gold break-all">{cfg.business_email}</a></li>
            <li className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-gold" /><a data-testid="footer-phone" href={`tel:${cfg.business_phone.replace(/\s+/g,'')}`} className="hover:text-gold">{cfg.business_phone}</a></li>
            <li className="flex items-start gap-3"><MessageCircle size={16} className="mt-0.5 text-gold" />
              <span>
                <a data-testid="footer-whatsapp-1" target="_blank" rel="noreferrer" href={`https://wa.me/${cfg.business_whatsapp}`} className="hover:text-gold block">WhatsApp: +{cfg.business_whatsapp}</a>
                {cfg.business_whatsapp_secondary && (
                  <a data-testid="footer-whatsapp-2" target="_blank" rel="noreferrer" href={`https://wa.me/${cfg.business_whatsapp_secondary}`} className="hover:text-gold block mt-1">WhatsApp: +{cfg.business_whatsapp_secondary}</a>
                )}
              </span>
            </li>
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-gold shrink-0" /><span data-testid="footer-address">{cfg.business_address}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© {new Date().getFullYear()} {cfg.business_name}. All rights reserved.</span>
          <span>Merchant Exporter · Importer · Agricultural Commodity Trader</span>
        </div>
      </div>
    </footer>
  );
}
